/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getProductLibProduct = /* GraphQL */ `query GetProductLibProduct($id: ID!) {
  getProductLibProduct(id: $id) {
    id
    brand
    brandType
    materialCode
    materialName
    barcode
    productHierachy
    name
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    description
    descriptionEN
    descriptionTH
    images
    functions
    tags
    lastUpdatedDate
    files {
      items {
        id
        brand
        brandType
        name
        materialCode
        materialName
        barcode
        productHierachy
        mediaType
        mediaTypeSub
        titleEN
        titleTH
        category
        subcategory
        collection
        color
        classifier
        packaging
        status
        length
        width
        height
        weight
        weightUnit
        baseSize
        path
        description
        functions
        tags
        createdAt
        updatedAt
        productLibProductFilesId
        __typename
      }
      nextToken
      __typename
    }
    eaPerCase
    eaPerPack
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLibProductQueryVariables,
  APITypes.GetProductLibProductQuery
>;
export const listProductLibProducts = /* GraphQL */ `query ListProductLibProducts(
  $filter: ModelProductLibProductFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLibProducts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      brand
      brandType
      materialCode
      materialName
      barcode
      productHierachy
      name
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      description
      descriptionEN
      descriptionTH
      images
      functions
      tags
      lastUpdatedDate
      files {
        nextToken
        __typename
      }
      eaPerCase
      eaPerPack
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLibProductsQueryVariables,
  APITypes.ListProductLibProductsQuery
>;
export const productByBrand = /* GraphQL */ `query ProductByBrand(
  $brand: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibProductFilterInput
  $limit: Int
  $nextToken: String
) {
  productByBrand(
    brand: $brand
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      brand
      brandType
      materialCode
      materialName
      barcode
      productHierachy
      name
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      description
      descriptionEN
      descriptionTH
      images
      functions
      tags
      lastUpdatedDate
      files {
        nextToken
        __typename
      }
      eaPerCase
      eaPerPack
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductByBrandQueryVariables,
  APITypes.ProductByBrandQuery
>;
export const productByPackaging = /* GraphQL */ `query ProductByPackaging(
  $packaging: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibProductFilterInput
  $limit: Int
  $nextToken: String
) {
  productByPackaging(
    packaging: $packaging
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      brand
      brandType
      materialCode
      materialName
      barcode
      productHierachy
      name
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      description
      descriptionEN
      descriptionTH
      images
      functions
      tags
      lastUpdatedDate
      files {
        nextToken
        __typename
      }
      eaPerCase
      eaPerPack
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductByPackagingQueryVariables,
  APITypes.ProductByPackagingQuery
>;
export const productBylastUpdatedDate = /* GraphQL */ `query ProductBylastUpdatedDate(
  $lastUpdatedDate: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibProductFilterInput
  $limit: Int
  $nextToken: String
) {
  productBylastUpdatedDate(
    lastUpdatedDate: $lastUpdatedDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      brand
      brandType
      materialCode
      materialName
      barcode
      productHierachy
      name
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      description
      descriptionEN
      descriptionTH
      images
      functions
      tags
      lastUpdatedDate
      files {
        nextToken
        __typename
      }
      eaPerCase
      eaPerPack
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductBylastUpdatedDateQueryVariables,
  APITypes.ProductBylastUpdatedDateQuery
>;
export const searchProductLibProducts = /* GraphQL */ `query SearchProductLibProducts(
  $filter: SearchableProductLibProductFilterInput
  $sort: [SearchableProductLibProductSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableProductLibProductAggregationInput]
) {
  searchProductLibProducts(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      brand
      brandType
      materialCode
      materialName
      barcode
      productHierachy
      name
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      description
      descriptionEN
      descriptionTH
      images
      functions
      tags
      lastUpdatedDate
      files {
        nextToken
        __typename
      }
      eaPerCase
      eaPerPack
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchProductLibProductsQueryVariables,
  APITypes.SearchProductLibProductsQuery
>;
export const getProductLibFile = /* GraphQL */ `query GetProductLibFile($id: ID!) {
  getProductLibFile(id: $id) {
    id
    brand
    brandType
    name
    materialCode
    materialName
    barcode
    productHierachy
    mediaType
    mediaTypeSub
    titleEN
    titleTH
    category
    subcategory
    collection
    color
    classifier
    packaging
    status
    length
    width
    height
    weight
    weightUnit
    baseSize
    path
    description
    functions
    tags
    createdAt
    updatedAt
    productLibProductFilesId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLibFileQueryVariables,
  APITypes.GetProductLibFileQuery
>;
export const listProductLibFiles = /* GraphQL */ `query ListProductLibFiles(
  $filter: ModelProductLibFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLibFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      brand
      brandType
      name
      materialCode
      materialName
      barcode
      productHierachy
      mediaType
      mediaTypeSub
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      path
      description
      functions
      tags
      createdAt
      updatedAt
      productLibProductFilesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLibFilesQueryVariables,
  APITypes.ListProductLibFilesQuery
>;
export const searchProductLibFiles = /* GraphQL */ `query SearchProductLibFiles(
  $filter: SearchableProductLibFileFilterInput
  $sort: [SearchableProductLibFileSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableProductLibFileAggregationInput]
) {
  searchProductLibFiles(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      brand
      brandType
      name
      materialCode
      materialName
      barcode
      productHierachy
      mediaType
      mediaTypeSub
      titleEN
      titleTH
      category
      subcategory
      collection
      color
      classifier
      packaging
      status
      length
      width
      height
      weight
      weightUnit
      baseSize
      path
      description
      functions
      tags
      createdAt
      updatedAt
      productLibProductFilesId
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchProductLibFilesQueryVariables,
  APITypes.SearchProductLibFilesQuery
>;
export const getProductLibAppIAM = /* GraphQL */ `query GetProductLibAppIAM($id: ID!) {
  getProductLibAppIAM(id: $id) {
    id
    username
    name
    email
    role
    departmentMain
    departmentSub
    editorBrandTypes
    approverBrandTypes
    skipNotificationBrandTypes
    notifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLibAppIAMQueryVariables,
  APITypes.GetProductLibAppIAMQuery
>;
export const listProductLibAppIAM = /* GraphQL */ `query ListProductLibAppIAM(
  $filter: ModelProductLibAppIAMFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLibAppIAM(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      name
      email
      role
      departmentMain
      departmentSub
      editorBrandTypes
      approverBrandTypes
      skipNotificationBrandTypes
      notifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLibAppIAMQueryVariables,
  APITypes.ListProductLibAppIAMQuery
>;
export const permissionByUsername = /* GraphQL */ `query PermissionByUsername(
  $username: String!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibAppIAMFilterInput
  $limit: Int
  $nextToken: String
) {
  permissionByUsername(
    username: $username
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      username
      name
      email
      role
      departmentMain
      departmentSub
      editorBrandTypes
      approverBrandTypes
      skipNotificationBrandTypes
      notifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PermissionByUsernameQueryVariables,
  APITypes.PermissionByUsernameQuery
>;
export const IAMByRole = /* GraphQL */ `query IAMByRole(
  $role: String!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibAppIAMFilterInput
  $limit: Int
  $nextToken: String
) {
  IAMByRole(
    role: $role
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      username
      name
      email
      role
      departmentMain
      departmentSub
      editorBrandTypes
      approverBrandTypes
      skipNotificationBrandTypes
      notifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.IAMByRoleQueryVariables, APITypes.IAMByRoleQuery>;
export const getProductLibBanner = /* GraphQL */ `query GetProductLibBanner($id: ID!) {
  getProductLibBanner(id: $id) {
    id
    order
    brand
    name
    mimeType
    path
    description
    periodStart
    periodEnd
    status
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLibBannerQueryVariables,
  APITypes.GetProductLibBannerQuery
>;
export const listProductLibBanners = /* GraphQL */ `query ListProductLibBanners(
  $filter: ModelProductLibBannerFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLibBanners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      order
      brand
      name
      mimeType
      path
      description
      periodStart
      periodEnd
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLibBannersQueryVariables,
  APITypes.ListProductLibBannersQuery
>;
export const bannerByBrand = /* GraphQL */ `query BannerByBrand(
  $brand: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibBannerFilterInput
  $limit: Int
  $nextToken: String
) {
  bannerByBrand(
    brand: $brand
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      order
      brand
      name
      mimeType
      path
      description
      periodStart
      periodEnd
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BannerByBrandQueryVariables,
  APITypes.BannerByBrandQuery
>;
export const getProductLibLtpPrice = /* GraphQL */ `query GetProductLibLtpPrice($id: ID!) {
  getProductLibLtpPrice(id: $id) {
    id
    ltpId
    materialCode
    pricePerDozen
    periodStart
    periodEnd
    lastSyncDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLibLtpPriceQueryVariables,
  APITypes.GetProductLibLtpPriceQuery
>;
export const listProductLibLtpPrices = /* GraphQL */ `query ListProductLibLtpPrices(
  $filter: ModelProductLibLtpPriceFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLibLtpPrices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ltpId
      materialCode
      pricePerDozen
      periodStart
      periodEnd
      lastSyncDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLibLtpPricesQueryVariables,
  APITypes.ListProductLibLtpPricesQuery
>;
export const ltpPriceByMaterialCode = /* GraphQL */ `query LtpPriceByMaterialCode(
  $materialCode: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibLtpPriceFilterInput
  $limit: Int
  $nextToken: String
) {
  ltpPriceByMaterialCode(
    materialCode: $materialCode
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ltpId
      materialCode
      pricePerDozen
      periodStart
      periodEnd
      lastSyncDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LtpPriceByMaterialCodeQueryVariables,
  APITypes.LtpPriceByMaterialCodeQuery
>;
export const ltpPriceByLastSyncDate = /* GraphQL */ `query LtpPriceByLastSyncDate(
  $lastSyncDate: String!
  $sortDirection: ModelSortDirection
  $filter: ModelProductLibLtpPriceFilterInput
  $limit: Int
  $nextToken: String
) {
  ltpPriceByLastSyncDate(
    lastSyncDate: $lastSyncDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ltpId
      materialCode
      pricePerDozen
      periodStart
      periodEnd
      lastSyncDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LtpPriceByLastSyncDateQueryVariables,
  APITypes.LtpPriceByLastSyncDateQuery
>;
